import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import styled from 'styled-components/macro';
import { iconButtonStyles } from '../../common/elements/Button';
import {
  fontSize,
  fontWeight,
  lineHeight,
  media,
  space,
} from '../../../theme/tokens';
import * as StaffCommon from '../../common/elements/Staff';

export const ClassroomCard = styled(StaffCommon.StaffCard).attrs({ as: 'div' })`
  display: grid;
  margin: 0;
  column-gap: ${space[3]};
  row-gap: ${space[1]};
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto;
  grid-template-areas:
    'cardHeader activeStatus'
    'teacher teacher'
    'topic delete'
    'module delete';
`;

export const ClassroomCardLi = styled.li`
  width: 100%;
  min-width: 0;
  margin: 0 0 ${space[4]};
  list-style: none;

  /* let the notification badge wrapper stretch so the card fills the row on mobile */
  & > .MuiBadge-root {
    width: 100%;
  }

  ${media.md`
    width: auto;
    margin: 0 ${space[4]} ${space[4]} 0;
  `}
`;

export const ClassroomHeader = styled.h3`
  grid-area: cardHeader;
  margin: 0 0 ${space[1]};
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.lg};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.staffCardHeaderColour};
  overflow-wrap: anywhere;
`;

const CardP = styled.p`
  margin: 0;
  font-weight: ${fontWeight.medium};
  font-size: ${fontSize.sm};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
  overflow-wrap: anywhere;
`;

export const Teacher = styled(CardP)`
  grid-area: teacher;
`;

export const Topic = styled(CardP)`
  grid-area: topic;
`;

export const Module = styled(CardP)`
  grid-area: module;
`;

export const Delete = styled.button.attrs({ $tone: 'danger' })`
  ${iconButtonStyles}
  grid-area: delete;
  justify-self: end;
  align-self: end;
`;

export const ActiveClassroom = styled(StaffCommon.StatusChip)`
  grid-area: activeStatus;
  align-self: start;
  justify-self: end;
`;

export const MagnifyingGlass = () => (
  <SearchIcon
    style={{
      fontSize: fontSize.xl,
    }}
  />
);

export * from '../../common/elements/Notifications';
export * from '../../common/elements/Staff';
